export const WORKING_HOURS = 
'Mon to Fri 9:30am - 6:30pm, Sat 10:30am - 5pm'

export const REG_EMAIL = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;




// WEBPACK FOOTER //
// ./src/constants/index.js